<template>
    <div id="works">
            <div class="port_open">WORKS</div> 
            <div class="worksPreview">
                <WorkPreview :lavoro="lavoro" v-for="lavoro in lavori" :key="lavoro.id"/>
            </div>   
    </div>
    
</template>
<script>
import axios from 'axios';
import WorkPreview from '../components/WorkPreview'
export default {
    data() {
        return {
            lavori: [],
        }
    },
    components:{WorkPreview},
    created(){
        axios.post('https://www.matteortili.com/scripts/fetchCategorie.php').then(function(response){
            console.log('Categorie: ',response);
        })
        axios.post('https://www.matteortili.com/scripts/fetchWorks.php').then(function(response){
            console.log('Works: ',response);
        })
        axios.post('https://www.matteortili.com/scripts/fetchLavori.php').then((response)=>{
            this.lavori = response.data;
        })
    }

}
</script>
<style scoped>
    #works{
        min-height: 100vh;
        max-width: 1200px;
        margin: 0 auto;
        padding-top: 100px;
        padding-left: 10px;
        padding-right: 10px;
    }
    .worksPreview{
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        grid-gap: 10px;
    }
    @media screen and (max-width: 800px) {
        .worksPreview {
            grid-template-columns: 1fr 1fr;
        }
    }
    @media screen and (max-width: 500px) {
        .worksPreview {
            grid-template-columns: 1fr;
        }
    }
    .port_open{
        text-align: center;
        font-size: 50pt;
        letter-spacing: 9px;
        text-transform: uppercase;
        color: white;
    }
</style>